'use strict'
import axios from "axios";
import store from '../store';

export default class Cpf {
    static Validate(cpf, flowSelected) {
        if(process.env.NODE_ENV === 'development') return this.developmentValidate(cpf, flowSelected);
        return axios.get( `../${store.getters.getConfig['validate_customer']}`, {
            headers: {
                'access_key': store.getters.getAccessKey,
                'metadata': store.getters.getMetadataCookie,
                'socialSecNo': window.btoa(cpf)
            },
            params: {
                typeTechnology: flowSelected
            }
        });
    }
 
    static developmentValidate(cpf, flowSelected) {
        return axios.get('/api/validateCustomer', {
            headers: {
                'access_key': store.getters.getAccessKey,
                'metadata': store.getters.getMetadataCookie,
                'socialSecNo': window.btoa(cpf)
            },
            params: {
                typeTechnology: flowSelected
            }
        });
    }
}